export * from './agris-detalle-insumo-page.component';
export * from './agregar-insumo-dialog';
export * from './agregar-ins-a-cotiz-existente-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/index.ts